export default function(value) {
	if (value !== '') {
        const priceLocale = parseInt(value).toLocaleString('ru');
        // const priceLocaleArr = String(priceLocale).split(/\s/);
        // const priceFormatted = priceLocaleArr.length >= 2 ? `${priceLocaleArr[0]}${'к'.repeat(priceLocaleArr.length - 1)}` : `${priceLocaleArr[0]}`;
        // return priceFormatted;
        return priceLocale;
    }
}